"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

/*
 * The header call to action, worded for the page you are on.
 *
 * The design varies it — "Create your account" for a business, "Create your
 * consultant account", "Apply as a trainee" — because the three are different
 * commitments and one shared label asks for none of them specifically. It is a
 * client component only because that wording depends on the route.
 */
const LABEL: Record<string, { text: string; href: string }> = {
  "/consultants": { text: "Create your consultant account", href: "/consultants#join" },
  "/trainees": { text: "Apply as a trainee", href: "/trainees#apply" },
};

/*
 * The descriptor beside the wordmark changes with the page too: "AI readiness"
 * for a business, "For consultants", "For trainees". It tells a visitor which
 * of the three doors they came through, which the brand alone cannot.
 */
const DESCRIPTOR: Record<string, string> = {
  "/consultants": "For consultants",
  "/trainees": "For trainees",
};

export function BrandDescriptor() {
  const path = usePathname();
  return (
    <span className="meta" style={{ marginLeft: 2, letterSpacing: ".14em", fontSize: 11 }}>
      {DESCRIPTOR[path] ?? "AI readiness"}
    </span>
  );
}

export function HeaderCta() {
  const path = usePathname();
  const { text, href } = LABEL[path] ?? { text: "Create your account", href: "/signup" };
  return (
    <span style={{ display: "flex", alignItems: "center", gap: 16 }}>
      {/*
        * NOT IN THE DESIGN, and added deliberately.
        *
        * The design's public header offers only the sign-up; the only way back
        * in is a "Log in" link on the sign-up form itself. That works for
        * somebody who has just registered and reads the whole page, and not at
        * all for a client returning three weeks later to read their report —
        * who would have to guess the URL. A returning customer having no door
        * is a worse problem than an extra link in the nav.
        */}
      <Link href="/login" style={{ fontSize: 14 }}>Log in</Link>
      <Link href={href} className="btn btn-primary blueprint"
            style={{ textDecoration: "none", padding: "9px 18px", fontSize: 14 }}>
        <i className="corner tl" aria-hidden="true" /><i className="corner tr" aria-hidden="true" />
        <i className="corner bl" aria-hidden="true" /><i className="corner br" aria-hidden="true" />
        {text}
      </Link>
    </span>
  );
}
